import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import React, { useState } from "react";
import { OrderFlow_V2 } from "../../OrderFlow/OrderFlow_V2";
import { NavPortalRoots } from "../../OrderFlow/utils/orderFlowUtils";
import { ConfirmationDialog } from "../../Shared/components/ConfirmationDialog";
import { ExtraSmallFab } from "../../Shared/components/Buttons/ExtraSmallFAB";
import { usePaymentForm } from "../../Shared/components/PaymentForm/usePaymentForm";
var ConfirmationDialogText;
(function (ConfirmationDialogText) {
    ConfirmationDialogText["SUBSCRIPTION_TITLE"] = "Are you sure you want to discard your subscription changes?";
    ConfirmationDialogText["SUBSCRIPTION_CONFIRM"] = "Yes, Discard Changes";
    ConfirmationDialogText["SUBSCRIPTION_CANCEL"] = "No, Keep Changes";
    ConfirmationDialogText["PAYMENT_TITLE"] = "Payment is required. Closing now may not save changes to your order(s). Are you sure?";
    ConfirmationDialogText["PAYMENT_CONFIRM"] = "Yes, Close Anyway";
    ConfirmationDialogText["PAYMENT_CANCEL"] = "No, Go Back";
})(ConfirmationDialogText || (ConfirmationDialogText = {}));
/**
 * * This modal is for editing active subscriptions by using the order flow application in an iframe.
 * * Flow modules with IsEditFlow set to true are loaded.
 *
 * @param props
 */
export const EditSubscriptionModal = ({ isOpen, onClose, currentOrderId, sku, dateChangesTakeEffect, subscriptionLinkId, startDate, subscriptionPeriod, }) => {
    const scrollToModalRef = React.useRef(null);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    const { balance, setBalance } = usePaymentForm();
    // If balance is defined in the PaymentFormContext then the PaymentForm is visible so change the confirmation modal text
    const dialogTitle = balance ? ConfirmationDialogText.PAYMENT_TITLE : ConfirmationDialogText.SUBSCRIPTION_TITLE;
    const confirmButtonText = balance
        ? ConfirmationDialogText.PAYMENT_CONFIRM
        : ConfirmationDialogText.SUBSCRIPTION_CONFIRM;
    const cancelButtonText = balance ? ConfirmationDialogText.PAYMENT_CANCEL : ConfirmationDialogText.SUBSCRIPTION_CANCEL;
    const onDiscardChangesClick = () => {
        setIsConfirmDialogOpen(false);
        // If balance is defined refresh the page to get updated subscription data
        if (balance) {
            window.top.location.href = "/Account/Subscriptions";
        }
        else {
            onClose();
            setBalance(undefined);
        }
    };
    const handleClose = (_, reason) => {
        if (reason !== "backdropClick") {
            onClose();
            setBalance(undefined);
        }
    };
    return (_jsxs(Dialog, Object.assign({ open: isOpen, onClose: handleClose, fullWidth: true, fullScreen: isMobile, maxWidth: isMobile ? false : "lg", disableEscapeKeyDown: true, scroll: "paper", PaperProps: { id: "edit-flow-dialog" }, sx: isMobile ? {
            height: "100%",
            '& .MuiBackdrop-root': {
                height: "100vh",
                backgroundColor: "rgba(255,255,255,1)"
            }
        } : {
            height: "100%"
        } }, { children: [_jsx(DialogTitle, Object.assign({ color: "primary", sx: {
                    display: "flex",
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "min-content",
                    "&.MuiTypography-root": {
                        padding: theme.spacing(2, 3),
                    },
                } }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", width: " 100%", alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "primary" }, { children: "Edit Subscription" })), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: () => setIsConfirmDialogOpen(true) })] })) })), _jsxs(DialogContent, Object.assign({ dividers: true, ref: scrollToModalRef, sx: { padding: isMobile ? 0 : "initial" } }, { children: [_jsx(ConfirmationDialog, { isOpen: isConfirmDialogOpen, dialogTitle: dialogTitle, cancelButtonText: cancelButtonText, confirmButtonText: confirmButtonText, onCancelButtonClick: () => setIsConfirmDialogOpen(false), onConfirmButtonClick: onDiscardChangesClick }), _jsx(OrderFlow_V2, { sku: sku, editOrderId: currentOrderId.toString(), dateChangesTakeEffect: dateChangesTakeEffect, subscriptionLinkId: subscriptionLinkId, startDate: startDate, subscriptionPeriod: subscriptionPeriod, closeEditModal: onClose, scrollToModalRef: scrollToModalRef })] })), _jsx(DialogActions, Object.assign({ sx: { p: 0 } }, { children: _jsx("div", { id: NavPortalRoots.EditSubscription, style: { width: "100%" } }) }))] })));
};
